import {load} from '@shopify/theme-sections';

const modal = document.querySelector('#modal');
const modalClose = document.querySelector('.modal__close');
const modalBg = document.querySelector('.modal__bg');

const url = new URL(window.location.href);
const isVisible = url.searchParams.get('customer_posted');

if (isVisible) {
  modal.classList.add('is-active');

  // Close modal on click of close button
  modalClose.addEventListener('click', (event) => {
    event.preventDefault();
    modal.classList.remove('is-active');
    url.searchParams.delete('customer_posted');
  });

  // Close modal on click of bg
  if (modalBg) {
    modalBg.addEventListener('click', (event) => {
      modal.classList.remove('is-active');
      url.searchParams.delete('customer_posted');
    });
  }

  load('*');
}
